export default __webpack_public_path__ + "static/media/misc-pantry1-2048w.585e52f5.png";